var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuizComment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 229,
    viewBox: "0 0 286 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter0_f_14047_28256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.665 34.9302C236.532 34.5314 245.727 42.8884 246.364 53.744L251.098 134.34C251.756 145.539 243.077 155.088 231.866 155.5L145.37 158.674C142.069 158.795 138.919 160.55 138.268 163.788C136.748 171.353 138.675 182.025 139.71 187.756C140.046 189.614 140.288 190.953 140.288 191.498C140.288 194.703 135.826 195.161 134.152 193.329C118.502 173.271 93.8432 164.296 78.8952 161.356C78.1819 161.216 77.4602 161.166 76.7337 161.193L60.2201 161.799C49.353 162.198 40.1586 153.841 39.521 142.985L34.787 62.3887C34.1292 51.1901 42.8088 41.6408 54.0191 41.2294L225.665 34.9302Z",
    fill: "#006AA4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234.693 19.2671C245.56 18.8683 254.755 27.2253 255.392 38.0809L260.751 129.318C261.409 140.516 252.73 150.066 241.519 150.477L156.724 153.589C146.161 153.977 136.701 160.124 137.38 170.673C137.744 176.337 138.756 181.941 139.425 185.646C139.79 187.669 140.053 189.126 140.053 189.719C140.053 193.207 135.197 193.706 133.376 191.712C117.111 170.867 91.9075 161.021 75.5031 157.389C73.2318 156.887 70.9049 156.738 68.5802 156.824L51.1917 157.462C40.3247 157.861 31.1303 149.504 30.4927 138.648L25.1337 47.4112C24.4759 36.2126 33.1555 26.6633 44.3658 26.2519L234.693 19.2671Z",
    fill: "#F2F9FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_14047_28256",
    x: 0.751953,
    y: 0.916504,
    width: 284.381,
    height: 227.484,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17,
    result: "effect1_foregroundBlur_14047_28256"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizComment);
export default __webpack_public_path__ + "static/media/quiz-comment.7082324a621e6740bccf5906ee1a9ecd.svg";
export { ForwardRef as ReactComponent };